/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user" | "PdpSharedMakeOfferButton_user" | "PdpSharedContactSupportButton_user">;
    readonly " $refType": "PdpRespSidebarContact_user";
};
export type PdpRespSidebarContact_user$data = PdpRespSidebarContact_user;
export type PdpRespSidebarContact_user$key = {
    readonly " $data"?: PdpRespSidebarContact_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSupportButton_user",
      "args": null
    }
  ]
};
(node as any).hash = '4b83d41a88b3b1a2e34e695fc81f1569';
export default node;
